export const mapsTranslations = {
  en: {
    pageTitle: 'Po River Maps',
    loading: 'Loading Maps...',
    noMapsMemory: 'No map information in memory - restart the app and try again',
    serverError: 'Problem receiving map data - checking if there are any in memory',
    surroundingArea: 'Surrounding Area Map',
    errorHeader: 'Data retrieval error',
    errorMessage: 'There was a problem retrieving the map data! Please restart the app and try again.',
    okButton: 'Ok'
  },
  it: {
    pageTitle: 'Carte del Fiume Po',
    loading: 'Caricamento Mappe...',
    noMapsMemory: 'Non sono presenti informazioni sulle mappe in memoria - riavviare l\'app e riprovare',
    serverError: 'Problema nella ricezione dei dati sulle mappe - controlliamo se ce ne sono in memoria',
    surroundingArea: 'Mappa dei dintorni',
    errorHeader: 'Errore di recupero dati',
    errorMessage: 'C\'è stato un problema nel recupero dei dati sulle mappe! Per favore riavvia l\'app e riprova.',
    okButton: 'Ok'
  }
};